import React from "react";

export const About = (props) => {
  return (
    <section id="aboutz">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
            {" "}
            <img src="img/portrait.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Meistä</h2>
                {props.data ? props.data.paragraphs.map((d, i) => <p key={`${d}-${i}`}>{d}</p>) : "loading"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
